import { render } from "./ModuleView.vue?vue&type=template&id=78b5dfb5"
import script from "./ModuleView.vue?vue&type=script&lang=js"
export * from "./ModuleView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__